'use strict';

/*
 * homeHeroCta.js -- reports clicks on the home hero CTA to GA4 and to Umbraco Engage.
 *
 * The CTA is an in-page jump (#section-footer), which GA4's enhanced measurement does not record, and seven
 * other home page buttons share the same href - so without these events the hero CTA is invisible.
 *
 * GA4: event `home_hero_cta_click` with
 *   link_url       the CTA href
 *   link_text      the CTA label
 *   hero_artwork   "animated" or "media" (the Home Hero "Show image instead of animated artwork" setting),
 *                  so the two artworks can be compared. Register it as an event-scoped custom dimension in
 *                  GA4 (Admin > Custom definitions) to report on it.
 * gtag only exists on www.proworks.com (see MainMaster.cshtml), so everywhere else the GA4 call is skipped.
 *
 * Engage: category "Home hero", action "CTA click", label = hero_artwork. Sent directly rather than relying on
 * Engage's GA4 bridge, which forwards only the event name (no params), only on the live host, and can miss an
 * event GA4 batches with others. The bridge will ALSO record each click, as "GA 4 - Bridging" /
 * "home_hero_cta_click" - report on the "Home hero" category and ignore the bridged copy. umbEngage loads on
 * every environment, and each environment has its own Engage database.
 *
 * Neither call blocks or delays the jump to the form.
 */

function onClick(e) {
    var link = e.currentTarget;
    var heroArtwork = link.getAttribute('data-hero-artwork') || '';

    if (typeof window.gtag === 'function') {
        window.gtag('event', 'home_hero_cta_click', {
            link_url: link.getAttribute('href') || '',
            link_text: (link.textContent || '').trim(),
            hero_artwork: heroArtwork
        });
    }

    if (typeof window.umbEngage === 'function') {
        window.umbEngage('send', 'event', 'Home hero', 'CTA click', heroArtwork);
    }
}

function init(root) {
    var scope = root || document;
    var links = scope.querySelectorAll('a[data-home-hero-cta]');
    for (var i = 0; i < links.length; i++) {
        links[i].addEventListener('click', onClick);
    }
}

module.exports = { init: init };
